import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import { CONTRIBUTION_LEVELS, DATE_FORMAT, DEFAULT_DISPLAY_VALUE } from '@/constants';
import {
  ContributionLevel,
  PromotionInfo,
  RisingStarDTO
} from '@/models';
import { formatDateToDisplay, getNumberOfSkipLevelByKey } from '@/helpers';
import {
  fetchPromotionInfo,
  sortArrByNumberField,
  sortArrByTextField,
  sortArrByUserDTOField
} from '@/services';
import Avatar from '@/components/common/avatar/Avatar.vue';
import ContributionLevelIcon from '@/components/common/contribution-level-icon/ContributionLevelIcon.vue';
import UserInformation from '@/components/common/user-information/UserInformation.vue';
import SummaryLevels from '@/components/pages/contribution-levels/summary-levels/SummaryLevels.vue';
import Pagination from '@/components/common/pagination/Pagination.vue';

@Component({
  components: { Avatar, ContributionLevelIcon, UserInformation, Pagination, SummaryLevels }
})
export default class LevelUpsTable extends Vue {
  private membersLevelUps: RisingStarDTO[] = [];
  private promotionInfo: PromotionInfo;
  private tableHeaderColumns = [
    {
      text: 'Member',
      value: 'user'
    },
    {
      text: 'From Level',
      value: 'previousLevel',
      class: 'grey--text'
    },
    {
      text: 'To Level',
      value: 'currentLevel',
      class: 'grey--text'
    },
    {
      align: 'end',
      text: 'Accumulated Pollens',
      value: 'accumulatedDrops',
      class: 'grey--text'
    },
    {
      align: 'end',
      text: 'Level(s) skipped',
      value: 'levelsSkipped',
      class: 'grey--text'
    }
  ];
  private page = 1;
  private pageCount = 0;
  private itemsPerPage = 10;

  customSort(items: RisingStarDTO[], fields: string[], isDescArr: boolean[]): RisingStarDTO[] {
    const field = fields[0];
    if (field) {
      const isDesc = isDescArr[0];
      switch (field) {
        case 'user': {
          return sortArrByUserDTOField(items, field, isDesc);
        }
        case 'previousLevel':
        case 'currentLevel': {
          return sortArrByTextField(items, field, isDesc);
        }
        case 'accumulatedDrops':
        case 'levelsSkipped': {
          return sortArrByNumberField(items, field, isDesc);
        }
        default: {
          return items;
        }
      }
    }
    return items;
  }

  displayDate(date: string): string {
    if (date) {
      return moment(date).format(DATE_FORMAT.DISPLAY);
    }
    return DEFAULT_DISPLAY_VALUE.DATE;
  }

  getContributionLevelFromText(contributionLevelText: string): ContributionLevel {
    return CONTRIBUTION_LEVELS[contributionLevelText];
  }

  async created(): Promise<void> {
    const { data: promotionInfo } = await fetchPromotionInfo();
    this.promotionInfo = promotionInfo;
    this.membersLevelUps = promotionInfo.risingStars.map(risingStar => ({
      ...risingStar,
      levelsSkipped: getNumberOfSkipLevelByKey(risingStar.previousLevel, risingStar.currentLevel)
    }));
  }

  onPageChange(page: number): void {
    this.page = page;
  }

  onItemsPerPageChange(itemsPerPage: number): void {
    this.itemsPerPage = itemsPerPage;
  }

  assessmentDateRange(): string {
    const { promotionInfo } = this;
    return `${formatDateToDisplay(promotionInfo?.startDate || '')} - ${formatDateToDisplay(promotionInfo?.endDate || '')}`;
  }
}
